<template>
  <DBox
    :id="'cmp-distribution-statement_list-statement-statement-summary'"
    :addButton="false"
    :addLink=" false "
    :addLinkLabel="'Add a Contact'"
    @menuClick="onRightMenuClick"
    :rightMenu="currentChannel == 'physical'?[{
            text: $t('price_export'),
            value: 'price_export',
          },{
            text: $t('sales_import_info'),
            value: 'sales_import_info',
          }]:[{
            text: $t('sales_import_info'),
            value: 'sales_import_info',
          }]"
  
  >
    <NTable
      class="dbox1"
      id="licence-licence_account-sidewindow-licences"
      :config="tableConfig"
      :headers="Headers"
      :items="statementSummary"
    >
      <template v-slot:item="{ item ,tdcon }">
        <tr>
          <td v-bind="tdcon('type')">
            <span>
              <template v-if="item['types']=='amount_of_statement'"> <b >{{$t(item['types'])}}</b> </template>
              <template v-else> {{$dft.capHead($t(item['types']))}} </template>
              

            </span>
           
          </td>
          <td v-if="currentChannel!='costs' && currentChannel!='income'" v-bind="tdcon('units')">
            <span>{{item['units']}}</span>
          </td>
          <td v-bind="tdcon('amounts')">
            <span v-if="item['amounts'] && item['amounts']!='- - -'">
              <template v-if="item['types']=='amount_of_statement'">
                <b>{{item['amounts']}} {{currencyISO}}</b>
              </template>
              <template v-else>
                {{item['amounts']}} {{currencyISO}}
              </template>
              
            </span>
            <span v-else>
              {{item['amounts']}}
            </span>
          </td>
         
        
             
             
                
                    
        </tr>
      </template>
    </NTable>


  </DBox>
</template>

<script>



import NTable from "../../../../plugins/datatable/datatable";
import { createNTableConfig } from '../../../../plugins/datatable';
import { createTableHeader } from "../../../../plugins/datatable";
import { onDetailsRowClicked } from '../../../../utility/route';
import { contactListLDTRoutes } from '../../../contacts/router/routes';
import { isTrue } from 'ramda-adjunct';


export default {
  props: {

    selectedStatementDetails:{
      type:Object,
      default: () => {}
    },
    statementSummary:{
      type:Array
    }

  },
  components: {
   
   
  },

  data: function() {
    return {
     tableConfig: createNTableConfig({
        headerStyle: 3,
        headerHeight: 32,
        fullHeight:true
      }),
    };
  },
  computed:{
    currencyISO:function(){
      const currencyArray = this.selectedStatementDetails?.currencies ||[]
      const currencyID = this.selectedStatementDetails?.statement?.currency_id ||''
      return currencyArray.length>0 ? currencyArray.find(x=>x.currency_id==currencyID).currency_iso:this.$store.getters.account.client.default_currency
    },    
    currentChannel:function(){
      return this.selectedStatementDetails?.stmt?.digital_physical
    },
    Headers: function () {
      const headers = [
        createTableHeader("type", { minw:145 }),
        createTableHeader("units", { ta:'right' }),
        createTableHeader('amounts',{ ta:'right'}),
      
      ];

     
      // console.log( "headers.filter(x=>x.value!='units'),,(this.currentChannel!='income')",(this.currentChannel!='costs'||this.currentChannel!='income'))
      if(this.currentChannel=='costs'||this.currentChannel=='income'){
         console.log( "headers.filter(x=>x.value!='units'),,(this.currentChannel!='income')", headers.filter(x=>x.value!='units'),":::::::::::",(this.currentChannel!='income'))
        return headers.filter(x=>x.value!='units');
      }
      
      return headers;
    },

    summaryItemLength:function(){
      return this.statementSummary.length;
    },


    // currentChannel:function(){
    //   return this.selectedStatementDetails?.stmt?.digital_physical
    // },
    // statementSummary:function(){
    //   if (!this.selectedStatementDetails?.statement?.json_data) {
    //     return;
    //   }
    //   console.log("STRING",this.selectedStatementDetails?.statement);
    //   const statementObject=this.selectedStatementDetails?.statement||{};
    //   const statementJSonObject= JSON.parse(this.selectedStatementDetails?.statement?.json_data)||{};
    //   console.log("PARSED JSON",statementObject)

    //   let summaryArray = []


    //   if(statementObject!={}){
    //     summaryArray = [
    //       {
    //         types:'sales',
    //         units:statementObject.sales_qty,
    //         amounts:statementObject.sales_amount ,
           
    //       },
    //       {
    //         types:'returns',
    //         units:statementObject.returns_qty,
    //         amounts:statementObject.return_amount ,
           
    //       },
    //       {
    //         types:'promos',
    //         units:statementObject.promo_qty,
    //         amounts:'' ,
         
    //       },
    //       {
    //         types:'foc',
    //         units:statementObject.foc_qty,
    //         amounts:'' ,
       
    //       },
    //       {
    //         types:'',
    //         units:'',
    //         amounts:'',
    //       },
    //       {
    //         types:'return_handling',
    //         units:'',
    //         amounts:statementObject.return_handling_amount, 
        
    //       },
    //       {
    //         types:'cost',
    //         units:'',
    //         amounts:statementObject.cost_amount,        
    //       },
    //       {
    //         types:'',
    //         units:'',
    //         amounts:'',

    //       },
    //       {
    //         types:'Calculate Total',
    //         units:'',
    //         amounts:statementObject.sales_amount ,
    //       },
    //       {
    //         types:'Rounding Difference',
    //         units:'',
    //         amounts:'- - -' ,
    //       },
    //       {
    //         types:'',
    //         units:'',
    //         amounts:'',
    //       },
    //       {
    //         types:'amount_of_statement',
    //         units:'',
    //         amounts:`${statementObject.statement_amount}` ,
    //       },
          
    //     ]
    //   }
      
    //   //return summaryArray

    //   if(this.currentChannel=='digital'){

    //     //console.log("digital",summaryArray.filter(x=>x.types!='foc' && x.types!='cost'))
    //     return summaryArray.filter(x=>x.types!='foc' && x.types!='cost')
    //   }
    //   else if(this.currentChannel=='physical'){
    //     return summaryArray
    //   }
    //   else if(this.currentChannel=='costs'||this.currentChannel=='income'){
    //     //console.log("costs",summaryArray.filter(x=>x.types!='sales'&& x.types!='returns' && x.types!='promos' && x.types!='foc' && x.types!='return_handling'))
    //     return summaryArray.filter(x=>x.types!='sales'&& x.types!='returns' && x.types!='promos' && x.types!='foc' && x.types!='return_handling')
    //   }
    //   else if(this.currentChannel=='performance'){
    //      return summaryArray
    //   }
    //   else if(this.currentChannel=='thirdparty'){
    //      return summaryArray.filter(x=>x.types!='cost' && x.types!='return_handling')
    //   }
    // },
  },
  methods:{
    onRightMenuClick(e){
      console.log('tabChange',e)
      this.$emit('tabChange',e)
    },
  },


}
</script>
<style lang="scss">
.cmp-distribution-statement_list-statement-statement-summary{
  .dt-ntable {
    background-color: #F7FFF2;
    tbody {
      tr:last-child{
        border-bottom: 0px;
      }
      // tr:nth-child(5) {
      //   td {
      //     border-right: 0px !important;
      //   }
      // }
      // tr:nth-child(8) {
      //       td {
      //     border-right: 0px !important;
      //   }
      // }
    }
  }
}
</style>